export default {
  scene: {
    background: 0xd2906c,
    shadow: 0x865059,
    fog: {
      color: 0xd2906c,
      near: 50,
      far: 300
    }
  },
  leaves: {
    width: 200,
    height: 80,
    depth: 200,
    position: {
      x: 0,
      y: 35,
      z: 0
    },
    wind: {
      speed: 10,
      rotation: Math.PI * 0.8
    },
    count: 70,
    size: 0.2,
    colors: [
      0xdb4112,
      0xee860b
    ]
  },
  environment: {
    rotation: Math.PI / 2,
    position: {
      x: 0,
      y: -5,
      z: 0
    }
  },
  character: {
    timeScale: 1.0,
    rotation: Math.PI / 2,
    position: {
      x: -14,
      y: -5,
      z: 4
    }
  },
  player: {
    timeScale: 1.1,
    rotation: Math.PI / 2,
    position: {
      x: -12,
      y: -5,
      z: -4
    }
  },
  speed: 3
}
